import { Injectable } from '@angular/core';
import {
  CreateMutationResult,
  injectMutation,
} from '@tanstack/angular-query-experimental';
import {
  ApiContactFormService,
  SubmitContactFormDto,
} from '../api-contact-form/api-contact-form.service';

@Injectable({
  providedIn: 'root',
})
export class ContactFormService {
  constructor(private readonly apiContactFormService: ApiContactFormService) {}

  public submit(): CreateMutationResult<void, Error, SubmitContactFormDto> {
    return injectMutation(() => ({
      mutationFn: (variables: SubmitContactFormDto) =>
        this.apiContactFormService.submit(variables),
    }));
  }
}
